"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SvgBulletList = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Svg = _interopRequireDefault(require("./Svg"));

var SvgBulletList = function SvgBulletList(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["size", "title", "desc", "titleId", "descId"]);
  return _react["default"].createElement(_Svg["default"], (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: "currentcolor"
  }, props), !!title && _react["default"].createElement("title", {
    id: titleId
  }, title), !!desc && _react["default"].createElement("desc", {
    id: descId
  }, desc), _react["default"].createElement("g", {
    className: "BulletList_svg__nc-icon-wrapper"
  }, _react["default"].createElement("path", {
    d: "M3 0a3 3 0 100 6 3 3 0 100-6zM3 9a3 3 0 100 6 3 3 0 100-6zM3 18a3 3 0 100 6 3 3 0 100-6zM9 1.5h15v3H9zM9 10.5h15v3H9zM9 19.5h15v3H9z"
  })));
};

exports.SvgBulletList = SvgBulletList;
SvgBulletList.isIcon = true;
SvgBulletList.defaultProps = {
  size: 24,
  'aria-hidden': 'true',
  focusable: 'false'
};
var _default = SvgBulletList;
exports["default"] = _default;